import { render, staticRenderFns } from "./CollectionTile.vue?vue&type=template&id=6bc784e4&scoped=true"
import script from "./CollectionTile.vue?vue&type=script&lang=js"
export * from "./CollectionTile.vue?vue&type=script&lang=js"
import style0 from "./CollectionTile.vue?vue&type=style&index=0&id=6bc784e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc784e4",
  null
  
)

export default component.exports